"use client";

import { useEffect } from "react";

/**
 * Next.js 16+ renders the floating "Issue" pill inside `nextjs-portal` → ShadowRoot.
 * Global CSS cannot target it, so we hide the badge host inside the shadow tree in dev only.
 * Full-screen error overlay still works; this only removes the corner pill.
 */
export default function HideNextDevBadge() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;

    const hideInShadow = (root: ShadowRoot | Document) => {
      root.querySelectorAll<HTMLElement>("[data-next-badge-root]").forEach((el) => {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
      });
      root.querySelectorAll<HTMLElement>("[data-next-badge]").forEach((el) => {
        el.style.setProperty("display", "none", "important");
      });
    };

    const scan = () => {
      const portal = document.querySelector("nextjs-portal");
      if (portal?.shadowRoot) hideInShadow(portal.shadowRoot);
    };

    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);

  return null;
}
